import { formatDateTime } from "@/common/utils/formatters";
import { DownloadIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { FiscalDocumentData } from "../types/fiscalDocument.type";
import { billingFiscalDocumentsStatus } from "../constants/billFiscalDocumentsStatus.constant";
import FiscalDocumentChangeStatusModal from "../components/DocumentsTab/FiscalDocumentChangeStatusModal";

export class BillFiscalDocumentsTransformer {
  static tableTransformer() {
    return (fiscalDocuments: FiscalDocumentData[]) => {
      return fiscalDocuments.map((fiscalDocument) => {
        const link = fiscalDocument.link || fiscalDocument.pdf?.url || fiscalDocument.xml?.url;

        return {
          ...fiscalDocument,
          status: fiscalDocument?.status ? billingFiscalDocumentsStatus[fiscalDocument?.status as keyof typeof billingFiscalDocumentsStatus] : '',
          author: fiscalDocument.uploaded_by ? fiscalDocument.uploaded_by.full_name : '',
          issued_at: fiscalDocument.issued_at ? formatDateTime(new Date(fiscalDocument.issued_at)) : '',
          failure_reason: fiscalDocument.failure_reason ? fiscalDocument.failure_reason : '',
          confirmed_at: fiscalDocument.confirmed_at ? formatDateTime(new Date(fiscalDocument.confirmed_at)) : '',
          canceled_at: fiscalDocument.canceled_at ? formatDateTime(new Date(fiscalDocument.canceled_at)) : '',
          actions: (
            <div className="flex items-center gap-4">
              <FiscalDocumentChangeStatusModal fiscalDocument={fiscalDocument} />

              {link ? (
                <Link to={link} target="_blank">
                  <DownloadIcon strokeWidth={1} />
                </Link>
              ) : ''}
            </div>
          ),
        };
      });
    };
  }
}
